export default __webpack_public_path__ + "static/media/loscopihues.58683fd7.jpg";